import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './icon.scss'

const __svgsprite__ = {
	path: '../../../assets/img/icons/*.svg',
	name: 'src/assets/img/[hash].icons.svg',
}
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svgsprite__)

const Icon = ({ name, className, fitToParent, ...rest }) => {
	const iconClass = 'o-icon'
	const cssClasses = classNames(
		iconClass,
		`${iconClass}--${name}`,
		fitToParent && `${iconClass}--fit-to-parent`,
		className && className
	)

	return (
		<svg className={cssClasses} {...rest}>
			<use xlinkHref={`#icon--${name}`} />
		</svg>
	)
}

Icon.propTypes = {
	name: PropTypes.string,
	className: PropTypes.string,
	fitToParent: PropTypes.bool,
}

Icon.defaultProps = {
	name: '',
	className: null,
	fitToParent: false,
}

export default Icon
